import React from 'react'
import cloneDeep from 'lodash/cloneDeep'
import groupBy from 'lodash/groupBy'
import values from 'lodash/values'
import { SelectUnit, SelectUnitRow } from '../../types'
import {
  getRow0,
  getRow1,
  getRow2,
  getRow3,
  getRow4,
  getSelectedIndividualUnits,
  getSelectedUnits,
} from '../../selectors'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from '../../reducer'

export const SelectUnitCallback = () => {
  const dispatch = useDispatch()
  const row0 = useSelector(getRow0)
  const row1 = useSelector(getRow1)
  const row2 = useSelector(getRow2)
  const row3 = useSelector(getRow3)
  const row4 = useSelector(getRow4)
  const selectedUnits = useSelector(getSelectedUnits) as SelectUnit[]
  const selectedIndividualUnits = useSelector(
    getSelectedIndividualUnits
  ) as SelectUnit[]

  const onSetSelected = React.useCallback(
    (row: SelectUnitRow[], selected: SelectUnitRow) => {
      let _selectedIndividualUnits = cloneDeep(selectedIndividualUnits)
      let didChange = false
      const updatedRow = cloneDeep(row).map((x) => {
        if (x.unitNumber === selected.unitNumber) {
          if (!x.isSelected) {
            x.isSelected = true
            _selectedIndividualUnits.push(x as unknown as SelectUnit)
            didChange = true
          } else {
            x.isSelected = false
            _selectedIndividualUnits = _selectedIndividualUnits.filter(
              (xx) => x.id !== xx.id
            )
            didChange = true
          }
        }
        return x
      })
      if (didChange) {
        dispatch(
          actions.onSelectedIndividualUnits(_selectedIndividualUnits)
        )
      }
      return updatedRow
    },
    [selectedIndividualUnits, dispatch]
  )

  const onCheckSelected = React.useCallback(
    (
      selected: SelectUnitRow,
      _row0: SelectUnitRow[],
      _row1: SelectUnitRow[],
      _row2: SelectUnitRow[],
      _row3: SelectUnitRow[],
      _row4: SelectUnitRow[]
    ) => {
      const combined = _row0
        .concat(_row1)
        .concat(_row2)
        .concat(_row3)
        .concat(_row4)
        .filter((x) => x.isSelectable)

      const grouped = groupBy(combined, 'size')
      const groupedValues = values(grouped)

      let _isValid = true
      selectedUnits.forEach((item) => {
        let _qty = 0
        let _count = 0
        groupedValues.forEach((x) => {
          x.forEach((y) => {
            const isSizeSelected = y.size === selected.size
            const isSizeItem = y.size === item.size
            const isClimateSelected = y.isClimate === selected.isClimate
            const isCoveredSelected = y.isCovered === selected.isCovered
            const isClimateItem = y.isClimate === item.isClimate
            const isCoveredItem = y.isCovered === item.isCovered
            const isSizeEqual = isSizeSelected && isSizeItem
            const isClimateEqual = isClimateSelected && isClimateItem
            const isCoveredEqual = isCoveredSelected && isCoveredItem

            if (
              (isSizeEqual && isClimateEqual) ||
              (isSizeEqual && isCoveredEqual)
            ) {
              const qty = parseInt(String(item.value ?? ''), 10)
              _qty = Number.isNaN(qty) ? 0 : qty
              if (y.isSelected) _count++
            }
          })
          if (_count > _qty) _isValid = false
        })
      })

      return _isValid
    },
    [selectedUnits]
  )

  return {
    onSelectUnit: React.useCallback(
      (selected: SelectUnitRow) => {
        if (selected.isUnavailable || !selected.isSelectable) return

        const _row0 = onSetSelected(row0, selected)
        const _row1 = onSetSelected(row1, selected)
        const _row2 = onSetSelected(row2, selected)
        const _row3 = onSetSelected(row3, selected)
        const _row4 = onSetSelected(row4, selected)

        const check = onCheckSelected(
          selected,
          _row0,
          _row1,
          _row2,
          _row3,
          _row4
        )
        if (check) {
          dispatch(
            actions.onAllRows({
              row0: _row0,
              row1: _row1,
              row2: _row2,
              row3: _row3,
              row4: _row4,
            })
          )
        }
      },
      [
        row0,
        row1,
        row2,
        row3,
        row4,
        selectedUnits,
        dispatch,
        onCheckSelected,
        onSetSelected,
      ]
    ),
  }
}
